/*
 * @Author: liuqing
 * @Date: 2021-05-25 11:12:37
 * @LastEditTime: 2021-06-29 16:45:40
 * @LastEditors: Tarzan
 * @Description: In User Settings Edit
 * @FilePath: \mall_pc\src\common\Enum\EnumBase.js
 */
export class EnumBase {
    constructor (elv) {
        this.elv = elv
		this.l2vList = this.elvMapL2vList()
		this.e2vList = this.elvMapE2vList()
		this.v2lList = this.elvMapV2lList()
    }

    elvMapL2vList () {
        const elv = this.elv
        const l2vList = elv.map(item => {
			return {
				label: item.label,
				value: item.value
			}
		})
        return l2vList
    }

	elvMapE2vList () {
	    const elv = this.elv
		const obj = {}
	    elv.map(item => {
			obj[item.key] = item.value
		})
	    return obj
	}

	elvMapV2lList () {
		const elv = this.elv
		const obj = {}
	    elv.map(item => {
			obj[item.value] = item.label
		})
	    return obj
	}

}
